import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {TimelineLite} from "gsap";

export class PearlHarborFSOutroPresentation implements FlowStatePresentation {
    private _flowStateController: FlowStateController;
    private _skipped:boolean;

    constructor() {
    }

    private skip(tl:TimelineLite):void {
        if (tl) {
            tl.progress(1);
        }
        this._skipped = true;
    }


    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        this._skipped = false;
        const mainTL:TimelineLite = new TimelineLite();
        flowStateController.setSkipCallback(() => this.skip(mainTL));
        mainTL.add(PearlHarbor.fsOutroView.show((index:number)=>this.complete(index)));

    }

    public shouldRun(): boolean {
        return (PearlHarborHelper.isFreeSpin(PearlHarbor.model.data.mode) && PearlHarbor.model.isNextNormal);
    }

    public complete(index: number):void {
        this._flowStateController.finish();
        PearlHarbor.setMode(PearlHarbor.model.data.nextMode);
        PearlHarbor.mainGameZoomContainer.showOnFSOutro();
        PearlHarbor.activeSymbolsBackground.showOnFSOutro();
    }
}